<template>
  <div class="content_line">
    <!-- <el-button v-if="buzAuth.indexOf('04000200') > -1" type="primary" plain size="small" @click="handleManage">发布版本</el-button>
    <el-tabs v-model="activeIndex">
      <el-tab-pane v-for="pf in allData" :key="pf.id" :label="pf.platformName" :name="pf.id">
        <el-timeline v-if="pf.versionList && pf.versionList.length > 0">
          <el-timeline-item v-for="(vl, vli) in pf.versionList" :key="vli" :timestamp="vl.date" placement="top">
            <div v-if="vli === 0" class="flag-latest">Latest release</div>
            <el-card>

              <h1>Release Notes for v{{ vl.version }}</h1>
              <h2 v-if="vl.feature">Features</h2>
              <div v-html="vl.feature.replace(/\n/g, '<br>')" />
              <h2 v-if="vl.fix">Fixes</h2>
              <div>{{ vl.fix }}</div>
              <h2 v-if="vl.change">Other Changes</h2>
              <div>{{ vl.change }}</div>

              <el-collapse v-model="vl.activeCollapse" accordion>
                <el-collapse-item name="1">
                  <template slot="title">
                    <span>Assets</span>
                    <i class="file-number">{{ vl.fileList.length || 0 }}</i>
                  </template>
                  <el-table :data="vl.fileList" :show-header="showHeader" border style="width: 100%">
                    <el-table-column label="文件">
                      <template slot-scope="scope">
                        <div class="fl">
                          <i class="el-icon-folder-opened" />
                          <a :href="scope.row.url" target="_blank">{{ scope.row.nameStr }}</a>
                        </div>
                        <div class="fr">{{ scope.row.size }}MB</div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-button v-if="buzAuth.indexOf('04000200') > -1" type="danger" plain size="small" style="margin-top: 10px;" @click="handleDel(vl)">删除该版本</el-button>
                </el-collapse-item>
              </el-collapse>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <div v-if="pf.versionList.length <= 0" class="nodata-version">暂无版本</div>
      </el-tab-pane>
    </el-tabs> -->
    <h5>软件版本下载功能, 已迁移至飞书知识库. 连接地址如下:  </h5>
    <a
      style="color:#0000FF"
      href="https://ucnjdmt92gxe.feishu.cn/wiki/FJ4cwX9uaiffqikmQCYcFUzlnPd?fromScene=spaceOverview"
      target="_blank"
      rel="noopener noreferrer"
    >
      https://ucnjdmt92gxe.feishu.cn/wiki/FJ4cwX9uaiffqikmQCYcFUzlnPd?fromScene=spaceOverview
    </a>
    <img style="margin-top:20px;width:100%" src="../../assets/version1.jpg" alt="">
  </div>
</template>

<script>
import { OssClient } from '@/utils/oss-client'
import { getDms, delDms } from '@/api/dms'
import { dateFormat } from '@/utils/filter'

export default {
  name: 'VersionLine',
  data: function() {
    return {
      activeIndex: 0,
      activeCollapse: ['1'],
      showHeader: false,
      allData: [
        {
          id: '0',
          platformName: 'DMS V3',
          versionList: []
        },
        {
          id: '1',
          platformName: 'DMS V4',
          versionList: []
        }
      ],
      buzAuth: []
    }
  },
  mounted() {
    this.getData()
    const buzAuth = JSON.parse(sessionStorage.getItem('info')).buzAuth
    if (buzAuth) {
      this.buzAuth = buzAuth
    }
  },
  methods: {
    getData() {
      this.allData[0].versionList = []
      this.allData[1].versionList = []
      getDms().then(response => {
        // console.log(response)
        this.getOssUrl(response.data)
      })
    },
    async getOssUrl(data) {
      const client = await OssClient('wondfo-soft')
      data && data.map((value, key) => {
        /* let path
        if (value.platform === 'Wondko-DMS-Pet') {
          path = process.env.VUE_APP_OSS_DMS_PET
        } else if (value.platform === 'Wondfo-DMS') {
          path = process.env.VUE_APP_OSS_DMS
        }*/
        value.date = dateFormat(value.date, 1)
        value.fileList && value.fileList.map((v, k) => {
          if (v.name && v.path) {
            let url = client.signatureUrl(v.path + '/' + v.name, { expires: 3600 * 12 })
            url = url.replace(/wondfo-soft.oss-cn-shenzhen.aliyuncs.com/, 'cdn-oss-soft.wondfo.cloud')
            v.url = url
          } else if (v.name && !v.path) {
            let url = client.signatureUrl(v.name, { expires: 3600 * 12 })
            url = url.replace(/wondfo-soft.oss-cn-shenzhen.aliyuncs.com/, 'cdn-oss-soft.wondfo.cloud')
            v.url = url
          }
          const array = v.name.split('/')
          v.nameStr = array[array.length - 1]
        })
        if (value.platform === 'Wondfo-DMS-V3') {
          this.allData[0].versionList.push(value)
        } else if (value.platform === 'Wondfo-DMS-V4') {
          this.allData[1].versionList.push(value)
        }
      })
      if (this.allData[0].versionList.length > 0) {
        this.allData[0].versionList[0].activeCollapse = ['1']
      }
      if (this.allData[1].versionList.length > 0) {
        this.allData[1].versionList[0].activeCollapse = ['1']
      }
    },
    handleManage() {
      this.$router.push({ name: 'manage' }).catch(err => { console.log(err) })
    },
    handleDel(row) {
      delDms({ id: row.id }).then(response => {
        this.getData()
      })
    }
  }
}
</script>

<style lang='scss'>
.content_line {
  font-family: "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Helvetica",
    "Arial", "sans-serif", "Apple Color Emoji", "Segoe UI Emoji";
  width: 980px;
  min-height: 300px;
  margin: 0 auto;
  .el-table__body {
    width: 100% !important;
  }
}
.el-tabs__content .nodata-version {
  text-align: center;
  color: #d1d5da;
}
.el-timeline-item__wrapper {
  .el-timeline-item__timestamp {
    margin-bottom: 16px;
  }
  .el-timeline-item__content {
    position: relative;
    .el-card {
      overflow: auto;
      .el-card__body {
        .title-version {
          color: #0366d6;
          font-size: 26px;
        }
        h1 {
          margin: 0 0 16px;
          padding-bottom: 10px;
          font-size: 32px;
          font-weight: 600;
          line-height: 1.25;
          // border-bottom: 1px solid #eaecef;
        }
        h2 {
          margin: 24px 0 16px;
          padding-bottom: 10px;
          font-size: 24px;
          font-weight: 600;
          line-height: 1.25;
          border-bottom: 1px solid #eaecef;
        }
        ul {
          margin: 0 0 16px;
          padding-left: 32px;
          display: block;
          list-style-type: disc;
          font-size: 16px;
          line-height: 1.5;
          // margin-block-start: 16px;
          // margin-block-end: 16px;
          // margin-inline-start: 0px;
          // margin-inline-end: 0px;
          // padding-inline-start: 40px;
          li {
            display: list-item;
            text-align: -webkit-match-parent;
            & + li {
              margin-top: 4px;
            }
            a {
              color: #0366d6;
              text-decoration: none;
            }
            a:visited {
              color: #0366d6;
              text-decoration: none;
            }
            a:hover {
              color: #0366d6;
              text-decoration: underline;
            }
            a:active {
              color: #0366d6;
            }
          }
        }
        .el-collapse {
          margin-top: 10px;
          border-bottom: none;
          .el-collapse-item {
            .el-collapse-item__header {
              font-weight: 600;
              border: none;
              span {
                font-size: 14px;
              }
              .file-number {
                display: inline-block;
                margin: 0 4px;
                padding: 2px 5px;
                font-size: 12px;
                font-weight: 600;
                line-height: 1;
                color: #586069;
                background-color: rgba(27, 31, 35, 0.08);
                border-radius: 20px;
                font-style: normal;
              }
            }
            .el-collapse-item__wrap {
              border: none;
              .el-table__body {
                .el-table__row td {
                  padding: 4px 0;
                  .fl {
                    float: left;
                    font-weight: 600;
                    i {
                      color: #586069;
                      margin-right: 8px;
                    }
                    a {
                      color: #0366d6;
                      text-decoration: none;
                    }
                    a:visited {
                      color: #0366d6;
                      text-decoration: none;
                    }
                    a:hover {
                      color: #0366d6;
                      text-decoration: underline;
                    }
                    a:active {
                      color: #0366d6;
                    }
                  }
                  .fr {
                    float: right;
                    color: #586069;
                  }
                }
              }
            }
          }
        }
      }
    }
    .flag-latest {
      position: absolute;
      top: -30px;
      left: 68px;
      display: inline-block;
      padding: 1px 4px;
      font-size: 12px;
      color: #28a745;
      border-radius: 2px;
      border: 1px solid #34d058;
    }
  }
}
</style>
